export default "__VITE_ASSET__b6ddb471__"